import {
  ApplicationStatus,
  BookingStatus,
  ListingStatus,
  ListingType,
  RequirementType,
} from "../../../../Redux/ApiCalls/Dashboard/MarketplaceAPI";

export const MARKETPLACE_GRADIENT = "linear-gradient(144.01deg, #ffc951 0%, #c94daa 130%)";

export const MARKETPLACE_COLORS = {
  brandPink: "#c94daa",
  brandYellow: "#ffc951",
  ink: "#171717",
  purple: "#7c4dff",
  sky: "#0ea5e9",
  success: "#16a34a",
  successDark: "#15803d",
  danger: "#ef4444",
  dangerDark: "#dc2626",
  muted: "#6b7280",
  warning: "#f09a3e",
  warningDark: "#c2410c",
  applicationPending: "#f59e0b",
  applicationAccepted: "#10b981",
  equipmentText: "#0369a1",
  videographerText: "#6d28d9",
};

export const STATUS_COLOR: Record<string, string> = {
  requested: MARKETPLACE_COLORS.warning,
  pending_payment: MARKETPLACE_COLORS.purple,
  confirmed: MARKETPLACE_COLORS.sky,
  accepted: MARKETPLACE_COLORS.success,
  rejected: MARKETPLACE_COLORS.danger,
  completed: MARKETPLACE_COLORS.muted,
  cancelled: MARKETPLACE_COLORS.danger,
};

export const APP_STATUS_COLOR: Record<ApplicationStatus, string> = {
  pending: MARKETPLACE_COLORS.warning,
  accepted: MARKETPLACE_COLORS.success,
  rejected: MARKETPLACE_COLORS.danger,
  withdrawn: MARKETPLACE_COLORS.muted,
};

export const LISTING_TYPE_COLORS: Record<ListingType, string> = {
  sale: MARKETPLACE_COLORS.purple,
  rent: MARKETPLACE_COLORS.sky,
  photographer: MARKETPLACE_COLORS.brandPink,
  videographer: MARKETPLACE_COLORS.warning,
};

export const TYPE_COLORS: Record<string, string> = {
  sale: MARKETPLACE_COLORS.purple,
  rent: MARKETPLACE_COLORS.sky,
  photographer: MARKETPLACE_COLORS.brandPink,
  videographer: MARKETPLACE_COLORS.warning,
  hiring: MARKETPLACE_COLORS.brandPink,
};

export const STATUS_COLORS: Record<ListingStatus | string, string> = {
  active: MARKETPLACE_COLORS.success,
  draft: MARKETPLACE_COLORS.muted,
  inactive: MARKETPLACE_COLORS.warning,
  sold: MARKETPLACE_COLORS.brandPink,
  fulfilled: MARKETPLACE_COLORS.purple,
  expired: MARKETPLACE_COLORS.danger,
};

export const BOOKING_STATUS_BADGE_STYLES: Record<BookingStatus, { bg: string; color: string; label: string }> = {
  requested: { bg: "rgba(251,146,60,0.12)", color: MARKETPLACE_COLORS.warningDark, label: "Requested" },
  accepted: { bg: "rgba(34,197,94,0.12)", color: MARKETPLACE_COLORS.successDark, label: "Accepted" },
  rejected: { bg: "rgba(239,68,68,0.12)", color: MARKETPLACE_COLORS.dangerDark, label: "Rejected" },
  completed: { bg: "rgba(14,165,233,0.12)", color: MARKETPLACE_COLORS.equipmentText, label: "Completed" },
  cancelled: { bg: "rgba(23,23,23,0.08)", color: "rgba(23,23,23,0.45)", label: "Cancelled" },
};

export const LISTING_TYPE_BADGE_STYLES: Record<ListingType, { bg: string; color: string; label: string }> = {
  rent: { bg: "rgba(14,165,233,0.1)", color: MARKETPLACE_COLORS.equipmentText, label: "🔑 Rent" },
  sale: { bg: "rgba(34,197,94,0.1)", color: MARKETPLACE_COLORS.successDark, label: "📦 Sale" },
  photographer: { bg: "rgba(201,77,170,0.1)", color: MARKETPLACE_COLORS.brandPink, label: "📷 Photographer" },
  videographer: { bg: "rgba(139,92,246,0.1)", color: MARKETPLACE_COLORS.videographerText, label: "🎬 Videographer" },
};

export const LISTING_STATUS_BADGE_STYLES: Record<string, { bg: string; color: string }> = {
  active: { bg: "rgba(34,197,94,0.1)", color: MARKETPLACE_COLORS.successDark },
  draft: { bg: "rgba(251,146,60,0.1)", color: MARKETPLACE_COLORS.warningDark },
  inactive: { bg: "rgba(23,23,23,0.08)", color: "rgba(23,23,23,0.5)" },
  sold: { bg: "rgba(14,165,233,0.1)", color: MARKETPLACE_COLORS.equipmentText },
  fulfilled: { bg: "rgba(14,165,233,0.1)", color: MARKETPLACE_COLORS.equipmentText },
  expired: { bg: "rgba(239,68,68,0.1)", color: MARKETPLACE_COLORS.dangerDark },
};

export const REQUIREMENT_TYPE_BADGE_STYLES: Record<RequirementType, { bg: string; color: string }> = {
  equipment_requirement: { bg: "rgba(14,165,233,0.1)", color: MARKETPLACE_COLORS.equipmentText },
  service_requirement: { bg: "rgba(139,92,246,0.1)", color: MARKETPLACE_COLORS.videographerText },
  bulk_custom_unit: { bg: "rgba(255,201,81,0.1)", color: "#FFC951" },
};

export const REQUIREMENT_STATUS_BADGE_STYLES: Record<string, { bg: string; color: string }> = {
  active: { bg: "rgba(34,197,94,0.1)", color: MARKETPLACE_COLORS.successDark },
  draft: { bg: "rgba(251,146,60,0.1)", color: MARKETPLACE_COLORS.warningDark },
  default: { bg: "rgba(23,23,23,0.07)", color: "rgba(23,23,23,0.5)" },
};

export const RECEIVED_APPLICATION_STATUS_STYLES: Record<ApplicationStatus, { color: string; bg: string; border: string }> = {
  pending: { color: MARKETPLACE_COLORS.applicationPending, bg: "rgba(245,158,11,0.10)", border: "rgba(245,158,11,0.25)" },
  accepted: { color: MARKETPLACE_COLORS.applicationAccepted, bg: "rgba(16,185,129,0.10)", border: "rgba(16,185,129,0.25)" },
  rejected: { color: MARKETPLACE_COLORS.danger, bg: "rgba(239,68,68,0.10)", border: "rgba(239,68,68,0.20)" },
  withdrawn: { color: MARKETPLACE_COLORS.muted, bg: "rgba(107,114,128,0.10)", border: "rgba(107,114,128,0.20)" },
};
